module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_750_1000.02f769a6.png";